import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim();
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    '[Six Pass] VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY são obrigatórias. ' +
      'Veja .env.example.',
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export enum OperationType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  LIST = 'list',
  GET = 'get',
  WRITE = 'write',
}

function maskEmail(email?: string | null): string | null {
  if (!email) return null;
  const [user, domain] = email.split('@');
  if (!domain) return '***';
  const maskedUser = user.length <= 2 ? '***' : `${user[0]}***`;
  return `${maskedUser}@${domain}`;
}

function maskUid(uid?: string | null): string | null {
  if (!uid) return null;
  return uid.length <= 8 ? '***' : `${uid.slice(0, 6)}…`;
}

export async function handleSupabaseError(
  error: unknown,
  operationType: OperationType,
  path: string | null,
) {
  const { data: sessionData } = await supabase.auth.getSession();
  const user = sessionData.session?.user ?? null;

  const errInfo = {
    error: error instanceof Error ? error.message : String(error),
    operationType,
    path,
    authInfo: {
      userId: maskUid(user?.id) ?? undefined,
      email: maskEmail(user?.email),
      emailVerified: user?.email_confirmed_at != null,
      isAnonymous: user?.is_anonymous ?? false,
      provider: user?.app_metadata?.provider ?? null,
    },
  };

  console.error('[Six Pass] Supabase error:', errInfo);
  return errInfo;
}
